import { merge } from 'ramda';
export var BalanceTypes;
(function (BalanceTypes) {
    BalanceTypes["SET_BALANCE"] = "SET_BALANCE";
    BalanceTypes["SET_ASSET"] = "SET_ASSET";
})(BalanceTypes || (BalanceTypes = {}));
export const balancesReducer = (state, action) => {
    switch (action.type) {
        case BalanceTypes.SET_BALANCE:
            return merge(state, {
                balances: merge(state.balances, { [action.payload.network]: action.payload.balance }),
            });
        case BalanceTypes.SET_ASSET:
            return merge(state, {
                assets: merge(state.assets, {
                    [action.payload.network]: merge(state.assets[action.payload.network] || {}, {
                        [action.payload.assetId]: action.payload.balance,
                    }),
                }),
            });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map